<template>
  <div class="templateUebersicht">
    <h2>Templates verwalten</h2>
    <div class="contentTemplateAvailable" v-if="template">
      <b-row>
        <b-column noPadding>
          <p><b>{{ template.name }}</b></p>
        </b-column>
      </b-row>
      <b-row reducedMargin>
        <b-column noPadding>
          <p>Erstelldatum: {{ formatDate(template.änderungsDatum) }}</p>
        </b-column>
      </b-row>
      <b-row>
        <b-column noPadding>
          <b-btn
            class="button"
            text
            color="blue"
            @click="templateBearbeiten()"
          >
            <v-icon small class="mr-1">
              mdi-pencil
            </v-icon>
            Bearbeiten
          </b-btn>
        </b-column>>
      </b-row>
      <b-row reducedMargin>
        <b-column noPadding>
          <b-btn
            text
            class="button"
            color="red"
            @click="zeigeLoeschenPopup = true"
          >
            <v-icon small class="mr-1">
              mdi-delete
            </v-icon>
            Löschen
          </b-btn>
        </b-column>
      </b-row>
    </div>
    <div class="contentNoTemplate" v-else>
      <v-row >
        <v-col>
          Es wurden noch keine Templates erstellt
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <b-btn @click="erstelleTemplate()">
            <v-icon small class="mr-1">
              mdi-plus
            </v-icon>
            Template erstellen
          </b-btn>
        </v-col>
      </v-row>
    </div>
    <LoeschenPopup
      v-if="zeigeLoeschenPopup"
      text="Wollen Sie das Template wirklich löschen?"
      @cancel="zeigeLoeschenPopup = false"
      @delete="templateLoeschen()"
    />
  </div>
</template>

<script>

import dateFormatService from '@/service/date-format-service';
import axios from 'axios';
import { mapGetters } from 'vuex';
import LoeschenPopup from '@/components/popups/LoeschenPopup';

export default {
  name: 'TemplateUebersicht',
  components: { LoeschenPopup },
  data() {
    return {
      template: null,
      zeigeLoeschenPopup: false
    };
  },
  methods: {
    loadTemplate() {
      axios.get(`/v1/vorlage/${this.getUserData.projekttraegerschaftName}`)
        .then((response) => {
          this.template = response.data;
        });
    },
    erstelleTemplate() {
      this.$router.push('/templateNeu');
    },
    templateBearbeiten() {
      this.$router.push('/template/' + this.getUserData.projekttraegerschaftName);
    },
    templateLoeschen() {
      axios.delete(`/v1/vorlage/${this.getUserData.projekttraegerschaftName}`)
        .then(() => {
          this.template = null;
        });
    },
    formatDate(date) {
      return dateFormatService.formatIsoDateString(date);
    },
  },
  computed: {
    ...mapGetters('userData', ['getUserData']),
  },
  created() {
    this.loadTemplate();
  }
};
</script>
<style lang="scss" scoped>

.templateUebersicht {
  .contentTemplateAvailable {
    text-align: right;
    margin: 100px auto;
    width: 200px;
    .button {
      padding: 0;
    }
  }
  .contentNoTemplate {
    text-align: center;
    margin: 100px 0;
  }
}

</style>